// @flow
import React, { PureComponent } from "react";
import { get } from "lodash";
import sequentialFormat from "@tvg/formatter/numeric";
import type { RaceTypeCodeEnum } from "@tvg/types/Race";
import {
  TrackMasterPicksRowWrapper,
  TopSectionWrapper,
  RunnerNumberWrapper,
  Position,
  RunnerName,
  RunnerOdds,
  InfoText
} from "./styled-components";
import RunnerNumber from "../../_atom/RunnerNumber";

export type Props = {
  horseName: string,
  info: string,
  number: number,
  runnerId: string,
  raceTypeCode: RaceTypeCodeEnum,
  scratched: boolean,
  isMorningLine: boolean,
  currentOddsNumerator: string,
  currentOddsDenominator: string
};

export default class TrackMasterPicksRow extends PureComponent<Props> {
  static defaultProps = {
    horseName: "",
    info: "",
    number: 0,
    runnerId: "",
    raceTypeCode: "T",
    scratched: false,
    isMorningLine: false,
    currentOddsNumerator: "99",
    currentOddsDenominator: "99"
  };

  printOdds() {
    if (this.props.scratched) {
      return "SCR";
    }

    const numerator = this.props.currentOddsNumerator;
    const denominator = this.props.currentOddsDenominator;
    const sameValue = numerator === denominator;
    const justNumerator =
      (numerator && denominator === null) || denominator === "";
    const oddsString =
      justNumerator || sameValue ? numerator : `${numerator}/${denominator}`;
    return !this.props.isMorningLine ? oddsString : `M/L: ${oddsString}`;
  }

  renderInfoText() {
    return (
      <InfoText data-qa-label="trackmaster-description">
        {this.props.info}
      </InfoText>
    );
  }

  render() {
    return (
      <TrackMasterPicksRowWrapper
        scratched={this.props.scratched}
        data-qa-label="trackmasterline"
      >
        <TopSectionWrapper>
          <Position data-qa-label="trackmaster-position">
            {sequentialFormat(get(this.props, "number"))}
          </Position>
          <RunnerNumberWrapper>
            <RunnerNumber
              runnerId={this.props.runnerId}
              raceTypeCode={this.props.raceTypeCode}
            />
          </RunnerNumberWrapper>
          <RunnerName
            scratched={this.props.scratched}
            data-qa-label="runnerBio-title"
          >
            {this.props.horseName}
          </RunnerName>
          <RunnerOdds
            scratched={this.props.scratched}
            data-qa-label="runnerOdds"
          >
            {this.printOdds()}
          </RunnerOdds>
        </TopSectionWrapper>
        {!this.props.scratched && this.renderInfoText()}
      </TrackMasterPicksRowWrapper>
    );
  }
}
